import React, { useEffect, useState } from 'react'
import './FurnitureForBudget.css'
import CMSHead from '../../UI-Controls/CMSHead/CMSHead'
import ImageGalleryPopup from '../../UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup';
import InfoPopUp from '../../InfoPopUp/InfoPopUp';
import arrowDown from '../../../Assets/Images/dropdown 20 x 20.png'
import { IoClose } from "react-icons/io5";
import axios from 'axios';
import { security_key, Url } from '../../../Services/Api';
import { uploadImage } from '../../../Services/functions';
import FurnitureForBudgetShimmer from '../Shimmers/FurnitureForBudgetShimmer/FurnitureForBudgetShimmer';
import SectionLoader from '../../UI-Controls/MainLoader/SectionLoader';
import GalleryUpload from '../../UI-Controls/GalleryUpload/GalleryUpload';
import { IoImageOutline } from "react-icons/io5";


const FurnitureForBudget = ({ handleOpen }) => {
  const [modalView, setModalView] = useState(false);
  const [selectedImage, setSelectedImage] = useState([])
  const [infoModal, setInfoModal] = useState(false);
  const [uploadedStatus, setUploadedStates] = useState('');
  const [mediaDeta, setMediaData] = useState([])
  const [budgetCategory, setbudgetCategory] = useState(null)
  const [selectCategoryData, setSelectCategoryData] = useState([])
  const [budgetPayload, setBudgetPayload] = useState({
    "sectional_schema": {
      "furniture_for_every_budget": [
        {
          "img": '',
          "sale": '',
          "shopNow": "Shop now",
          "uid": 0,
          "max_price": 0,
          "category": '',
          "deskImg": '',
          "mobImg": '',
        },
        {
          "img": '',
          "sale": '',
          "shopNow": "Shop now",
          "uid": 0,
          "max_price": 0,
          "category": '',
          "deskImg": '',
          "mobImg": '',
        },
        {
          "img": '',
          "sale": '',
          "shopNow": "Shop now",
          "uid": 0,
          "max_price": 0,
          "category": '',
          "deskImg": '',
          "mobImg": '',
        }
      ]
    }
  })
  const [imageSendPayload, setImageSendPayload] = useState({
    file: null,
    alt_text: '',
    title: '',
    description: '',
    link_url: '',
  });
  const [imgIndex, setImgIndex] = useState(null)
  const [imgBanner1Index, setImgBanner1Index] = useState(null)
  const [imgBanner2Index, setImgBanner2Index] = useState(null)
  const [loading, setLoading] = useState(false)
  const [focus, setFocus] = useState(null)
  const [combinedState, setCommbinedState] = useState(budgetPayload)
  const [openModalFor, setOpenModalFor] = useState(null)

  const handleShowInfoModal = () => {
    setInfoModal(true)
  }

  const handleCloseInfoModal = () => {
    setInfoModal(false);
  }

  const handleModalOpen = (index, modalFor) => {
    setModalView(true)

    setOpenModalFor(modalFor)
    if (modalFor === "mainImage") {
      setImgIndex(index)
    } else if (modalFor === "deskImg") {
      setImgBanner1Index(index)
    } else if (modalFor === "mobImg") {
      setImgBanner2Index(index)
    } else {

    }
  }


  const handleModalClose = () => {
    setModalView(false)
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const api = `${Url}/api/v1/media/global/add`

    if (file) {
      setImageSendPayload((prevData) => ({
        ...prevData,
        file: file,
      }));
      setUploadedStates('loading');
      const imagePayloadToSend = new FormData();
      imagePayloadToSend.append('image', file);
      imagePayloadToSend.append('alt_text', imageSendPayload.alt_text);
      imagePayloadToSend.append('title', imageSendPayload.title);
      imagePayloadToSend.append('description', imageSendPayload.description);
      imagePayloadToSend.append('image_url', imageSendPayload.image_url);
      imagePayloadToSend.append('link_url', imageSendPayload.link_url);
      try {
        await uploadImage(imagePayloadToSend, api, setUploadedStates);
        setUploadedStates('success');
        getFurnitureForEveryBudgetImages()
      } catch (error) {
        console.error("Image upload failed:", error);
        setUploadedStates('error');
      }
    }
  }

  const getFurnitureForEveryBudgetImages = async () => {
    try {
      const response = await axios.get(`${Url}/api/v1/media/global/get`);
      setMediaData(response.data.media)
    } catch (error) {
      console.error('Error', error);
    }
  }

  useEffect(() => {
    getFurnitureForEveryBudgetImages()
  }, [])

  // const handleImageSelect = (image,imageFor) => {
  //   setSelectedImage(image)

  //   setBudgetPayload((prevState) => ({
  //     ...prevState,
  //     sectional_schema: {
  //       ...prevState.sectional_schema,
  //       furniture_for_every_budget: prevState.sectional_schema.furniture_for_every_budget.map((selectedImage, i) =>
  //         i === imgIndex ? { ...selectedImage, img: image.image_url } : selectedImage
  //       )
  //     }
  //   }))
  //   setModalView(false);
  // };


  const handleImageSelect = (image) => {
    setSelectedImage(image);

    setBudgetPayload((prevState) => {
      const updatedSectionalSchema = { ...prevState.sectional_schema };

      if (openModalFor === 'mainImage') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (selectedImage, i) =>
            i === imgIndex ? { ...selectedImage, img: image.image_url } : selectedImage
        );
      } else if (openModalFor === 'deskImg') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (item, i) =>
            i === imgBanner1Index ? { ...item, deskImg: image.image_url } : item
        );
      } else if (openModalFor === 'mobImg') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (item, i) =>
            i === imgBanner2Index ? { ...item, mobImg: image.image_url } : item
        );
      }

      // ✅ RETURN the new payload
      return {
        ...prevState,
        sectional_schema: updatedSectionalSchema
      };
    });

    setModalView(false);
  };



  const handleBudgetCategory = (index) => {
    setbudgetCategory((prevInd) => prevInd === index ? null : index);
  }

  useEffect(() => {
    const fetchCategoryForBudget = async () => {
      const api = `/api/v1/productCategory/get?parent=0`;
      try {
        const response = await axios.get(`${Url + api}`);
        console.log("check selected category", response.data)
        setSelectCategoryData(response.data.categories);
      } catch (error) {
        console.error("Error geting categories", error);
      }
    }
    fetchCategoryForBudget()
  }, [])

  const handleCategoryData = (item, ind) => {
    setBudgetPayload((prevState) => ({
      ...prevState,
      sectional_schema: {
        ...prevState.sectional_schema,
        furniture_for_every_budget: prevState.sectional_schema.furniture_for_every_budget.map((entry, index) =>
          index === ind
            ? {
              ...entry,
              category: item.slug,
              uid: item.uid
            } : entry
        ),

      },
    }));
    setbudgetCategory(null);
  };

  const handlePriceChange = (e, index, field) => {
    const newValue = e.target.value;
    const updatedValue = field === 'max_price' ? parseFloat(newValue) : newValue;
    setBudgetPayload(prevState => {
      const updatedFurnitureBudget = [...prevState.sectional_schema.furniture_for_every_budget];
      updatedFurnitureBudget[index] = {
        ...updatedFurnitureBudget[index],
        [field]: updatedValue
      };
      return {
        ...prevState,
        sectional_schema: {
          ...prevState.sectional_schema,
          furniture_for_every_budget: updatedFurnitureBudget
        }
      };
    });
  };

  useEffect(() => {
    console.log("budget payload", budgetPayload)
  }, [budgetPayload])

  const updateFurnitureForEveryBudget = async () => {
    const api = `/api/v1/content1/edit`
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };

    try {
      setLoading(true)
      await axios.put(`${Url + api}`, {
        sectional_schema: {
          furniture_for_every_budget: budgetPayload.sectional_schema.furniture_for_every_budget
        }
      },{headers:headers})
        .then(response => {
          handleOpen("Furniture For Budget Data Update")
        })
        .catch(error => {
          console.log("error updating products", error)
          handleOpen("Eror Updating Furniture ")
        })

    } catch (error) {
      console.error("updating products failed", error);
      handleOpen("UnExpected Server Error")
    }
    setLoading(false)
  }

  const handleChangeValueType = (index) => {
    setFocus(index)
  }

  const handleFocusOut = () => {
    setFocus(null)
  }

  const handleDelete = (index, openModalFor) => {
    setBudgetPayload((prevState) => {
      const updatedSectionalSchema = { ...prevState.sectional_schema };

      if (openModalFor === 'mainImage') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (item, i) => (i === index ? { ...item, img: '' } : item)
        );
      } else if (openModalFor === 'deskImg') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (item, i) => (i === index ? { ...item, deskImg: '' } : item)
        );
      } else if (openModalFor === 'mobImg') {
        updatedSectionalSchema.furniture_for_every_budget = updatedSectionalSchema.furniture_for_every_budget.map(
          (item, i) => (i === index ? { ...item, mobImg: '' } : item)
        );
      }

      return {
        ...prevState,
        sectional_schema: updatedSectionalSchema,
      };
    });
  };


  useEffect(() => {
    const getFurnitureForEveryBudgetProducts = async () => {
      const api = `/api/v1/content1/get`
      try {
        const response = await axios.get(`${Url + api}`)
        setBudgetPayload(response.data.landingPageContent)
        const apiData = response.data.landingPageContent
        if (apiData?.sectional_schema?.furniture_for_every_budget?.length > 0) {
          const mergedData = {
            ...budgetPayload,
            sectional_schema: {
              ...budgetPayload.sectional_schema,
              furniture_for_every_budget: apiData.sectional_schema.furniture_for_every_budget
            }
          };
          setCommbinedState(mergedData)
        } else {
          setCommbinedState(budgetPayload);
        }
      } catch (error) {
        console.log("error geting products", error);
      }
    }
    getFurnitureForEveryBudgetProducts()
  }, [])

  useEffect(() => { console.log("selected Category Data", selectCategoryData) }, [selectCategoryData])

  return (
    <div>

      <CMSHead
        heading={"Furniture For Every Budget"}
        buttonText={"Save"}
        isButtonVissible={true}
        handleShowInfoModal={handleShowInfoModal}
        sendImagesHomeSlider={updateFurnitureForEveryBudget}
      />
      {budgetPayload !== null ? (
        <div className='furniture-for-budget-main-container'>
          {loading && <SectionLoader />}
          <div className='furniture-for-budget-cards-container'>
            {[0, 1, 2].map((_, index) => (
              <div className='furniture-for-budget-card'>
                <div className='furniture-for-budget-image-upload-main-div'>
                  {budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.img ? (
                    <div className='furniture-for-budget-product-main-image-container'>
                      <button className='furniture-for-budget-img-delete-btn' onClick={() => handleDelete(index, "mainImage")} >
                        <IoClose size={15} color='#595959' />
                      </button>
                      <img className='furniture-for-budget-main-image' src={`${Url + budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.img}`} alt='main' />
                    </div>
                  ) : (
                    <GalleryUpload
                      openModal={() => handleModalOpen(index, "mainImage")}
                    />
                  )}

                </div>
                <div className='furniture-for-budget-card-footer'>
                  <div className='category-dropdown'>
                    <div className='category-drop-down-head' onClick={() => handleBudgetCategory(index)}>
                      <p className='select-category-heading'>{budgetPayload?.length !== 0 ? budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.category : 'Select Category'}</p>
                      <img src={arrowDown} alt='arrow down' />
                    </div>
                    <div className={`categor-drop-down-items ${budgetCategory === index ? 'show-drop-down-items' : ''}`}>
                      {selectCategoryData.map((item, innerIndex) => (
                        <p key={innerIndex} onClick={() => handleCategoryData(item, index)}>
                          {item.name}
                        </p>
                      ))}
                    </div>
                  </div>
                  <input
                    type='text'
                    placeholder='Price($)'
                    className='furniture-for-budget-price'
                    onFocus={() => handleChangeValueType(index)}
                    onBlur={() => handleFocusOut(index)}
                    value={budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.max_price || 0}
                    onChange={(e) => handlePriceChange(e, index, 'max_price')}
                  />
                  <input
                    type='text'
                    placeholder='Name'
                    className='furniture-for-budget-price'
                    value={budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.sale}
                    onChange={(e) => handlePriceChange(e, index, 'sale')}
                  />
                </div>
                <div className='bannerImagesFOEB'>
                  <div className='bannerImagesFOEBdesk'>
                    {budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.deskImg ?
                      <div className='furniture-for-budget-product-main-image-container'>
                        <button className='furniture-for-budget-img-delete-btn' onClick={() => handleDelete(index, "deskImg")} >
                          <IoClose size={15} color='#595959' />
                        </button>
                        <img className='furniture-for-budget-main-image banner' src={`${Url + budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.deskImg}`} alt='main' />
                      </div>
                      : <div onClick={() => {
                        handleModalOpen(index, "deskImg")
                      }} className='bannerImagesFOEB_upload_image'>
                        <IoImageOutline size={50} />
                        <h3>Desktop Banner</h3>
                      </div>}
                  </div>
                  <div className='bannerImagesFOEBmob' >
                    {budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.mobImg ?
                      <div className='furniture-for-budget-product-main-image-container'>
                        <button className='furniture-for-budget-img-delete-btn' onClick={() => handleDelete(index, "mobImg")} >
                          <IoClose size={15} color='#595959' />
                        </button>
                        <img className='furniture-for-budget-main-image banner' src={`${Url + budgetPayload?.sectional_schema?.furniture_for_every_budget?.[index]?.mobImg}`} alt='main' />
                      </div>
                      : <div onClick={() => {
                        handleModalOpen(index, "mobImg")
                      }} className='bannerImagesFOEB_upload_image'>
                        <IoImageOutline size={50} />
                        <h3>Mobile Banner</h3>
                      </div>}

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <FurnitureForBudgetShimmer />
      )}

      <ImageGalleryPopup
        showImageGalleryPopUp={modalView}
        handleModalView={handleModalClose}
        onImageSelect={handleImageSelect}
        imageSendPayload={imageSendPayload}
        data={mediaDeta}
        setImageSendPayload={setImageSendPayload}
        alt_text={imageSendPayload.alt_text}
        title={imageSendPayload.title}
        handleFileChange={handleFileChange}
        getData={getFurnitureForEveryBudgetImages}
        editGalleryImageApi={"/api/v1/media/global/"}
      />

      <InfoPopUp
        showInfoModal={infoModal}
        handleCloseInfoModal={handleCloseInfoModal}
      />
    </div>
  )
}

export default FurnitureForBudget